import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface ListRepairsQueryOptions {
  status?: Ref<"open" | "closed" | undefined>;
  limit?: Ref<number | undefined>;
  offset?: Ref<number | undefined>;
}

export const listRepairsQuery = (options: ListRepairsQueryOptions = {}) => {
  return queryOptions({
    queryKey: [
      "repairs",
      "list",
      options.status,
      options.limit,
      options.offset,
    ],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["listRepairs"][200]
    > =>
      handleClientMethod(
        getClient().GET("/repairs", {
          params: {
            query: {
              status: options.status?.value,
              limit: options.limit?.value,
              offset: options.offset?.value,
            },
          },
        }),
      ),
  });
};
